module.exports = __webpack_public_path__ + "career-icon-office.1Za_hVnp.svg";